import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Footer.css";
import { RiArrowRightSLine } from "react-icons/ri";
import { FaLocationDot, FaPhone } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import { FaXTwitter } from "react-icons/fa6"
import { FaYoutube } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footers = () => {
  return (
    <div>
      {/* <section className="vs-newsletter-wrapper bg-dark z-index-step1">
        <Container>
          <div className="position-relative">
            <div className="inner-wrapper bg-black position-absolute top-50 start-50 translate-middle w-100 px-60 py-40">
              <Row className="align-items-center justify-content-center">
                <Col xl={6} className="text-center text-xl-start mb-3 mb-xl-0">
                  <span className="sub-title2 mt-2">Newsletter</span>
                  <h2 className="mb-0 text-white">Get monthly updates</h2>
                </Col>
                <Col md={10} lg={8} xl={6}>
                  <form className="newsletter-style1 d-md-flex">
                    <input
                      type="email"
                      placeholder="Enter email address"
                      className="me-2 form-control"
                    />
                    <button className="vs-btn gradient-btn">
                      Subscribe Now
                    </button>
                  </form>
                </Col>
              </Row>
            </div>
          </div>
        </Container>
      </section> */}
      <footer className="footer-wrapper footer-layout1 bg-fluid bg-major-black position-relative">
        <div
          className="bg-fluid d-none d-none d-xl-block position-absolute start-0 top-0 w-100 h-100 background-image"
          // style={{
          //   backgroundImage:
          //     'url("https://html.vecurosoft.com/gamio/demo/Linkssets/img/bg/footer-bg-1-1.jpg")',
          // }}
        />
        <div className="footer-widget-wrapper dark-style1 z-index-common">
          
          <Container>
            <Row className="justify-content-between">
              {/* <Col md={6} lg={3} xl={4}>
                <div className="widget footer-widget pt-0">
                  <h3 className="widget_title">About Us</h3>
                  <div className="vs-widget-about">
                    <p className="about-text text-footer1 pe-xl-5">
                      The League of Legends offseason is in full effect and
                      teams are looking to sign new players to strengthen their
                      roster or to re-sign their current players.
                    </p>
                  
                  </div>
                </div>
              </Col> */}

            <div className="bottom-Logo">
              <div className="footer-logo">
                <img
                  src="/Images/ft-tunes-newlogo-white.png"
                  className="img-fluid logo"
                  alt="FT Tunes"
                />
              </div>

              <div className="social-icons">

                {/* Instagram */}
                <a
                  href="https://www.instagram.com/ft_tunes_/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram />
                </a>

                {/* WhatsApp */}
                <a
                  href="https://wa.me/918178035854"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp />
                </a>

              </div>
            </div>


              <Col xs={12} sm={6} md={6} lg={3}>
                <div className="widget widget_categories footer-widget">
                  <h3 className="widget_title">Company</h3>
                  <ul className="widget_title_list">
                    <li>
                      <Link to="/about">
                        <RiArrowRightSLine /> About us
                      </Link>
                    </li>
                     <li>
                        <Link to="/music-distribution-services">
                          <RiArrowRightSLine /> Services
                        </Link>
                      </li>
                    <li>
                      <Link to="/contact-us">
                        <RiArrowRightSLine /> Contact us
                      </Link>
                    </li>
                     <li>
                      <Link to="/career">
                        <RiArrowRightSLine /> Career
                      </Link>
                    </li>
                    {/* <li>
                      <Link to="/terms-of-service">
                        <RiArrowRightSLine /> Terms of Service
                      </Link>
                    </li> */}
                    {/* <li>
                      <Link to="/privacy-policy">
                        <RiArrowRightSLine />
                        Privacy Policy
                      </Link>
                    </li> */}
                    {/* <li>
                      <Link to="#">
                        <RiArrowRightSLine /> MS-XBOX
                      </Link>
                    </li> */}
                  </ul>
                </div>
                                <div className="widget footer-widget">
                  <h3 className="widget_title">Get in Touch </h3>
                  <div className="vs-widget-about">
                    <div className="footer-contact-us widget_title_list">
                      <FaLocationDot
                        className="icon-btn fal fa-map-marker-alt text-white"
                        size={20}
                      />
                      <p className="contact-info widget_title_list">
                        Nearest Metro: Dashrathpuri (Approx 100 Meter Distance){" "}
                        <br />
                        A2, 2nd Floor Palam Dabri Road, Mahavir Enclave Dwarka,
                        New Delhi - 110045 <br /> <br />{" "}
                        <b>LandMark - KFC/PizzaHut/DIY</b>
                      </p>
                    </div>
                      <div className="footer-contact-us">
                        <FaWhatsapp
                          className="icon-btn fal fa-phone text-white"
                          size={20}
                        />

                        <p
                          className="contact-info widget_title_list"
                          style={{ marginTop: "10px" }}
                        >
                          <a
                            href="https://wa.me/918178035854"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "none" }}
                          >
                            +91 81780 35854
                          </a>
                        </p>
                      </div>
                    {/* <p className="contact-info">
                        <i className="fal fa-envelope text-white" />
                        <Link to="mailto:info@example.com">info@example.com</Link>
                      </p> */}
                    <div className="footer-contact-us">
                      <MdEmail
                        className="icon-btn fal fa-phone text-white"
                        size={20}
                      />
                      <p className="contact-info" style={{ marginTop: "10px" }}>
                        <Link
                          to="mailto:support@fttunes.com"
                          style={{ textDecoration: "none" }}
                        >
                          music@fttunes.com
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
                <Col xs={12} sm={6} md={6} lg={3}>
                <div className="widget widget_categories footer-widget">
                  <h3 className="widget_title">Legal</h3>
                  <ul className="widget_title_list">
                    <li>
                      <Link to="/content-policy">
                        <RiArrowRightSLine /> Content Policy
                      </Link>
                    </li>
                    <li>
                      <Link to="/cookie-policy">
                        <RiArrowRightSLine /> Cookie Policy
                      </Link>
                    </li>
                    <li>
                      <Link to="/terms-of-service">
                        <RiArrowRightSLine /> Terms of Service
                      </Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">
                        <RiArrowRightSLine /> Privacy Policy
                      </Link>
                    </li>
                    <li>
                      <Link to="/refund-policy">
                        <RiArrowRightSLine /> Refund Policy
                      </Link>
                    </li>
                    <li>
                      <Link to="/artist-agreement">
                        <RiArrowRightSLine /> Artist Agreement
                      </Link>
                    </li>
                    <li>
                      <Link to="/label-agreement">
                        <RiArrowRightSLine /> Label Agreement
                      </Link>
                    </li>
                    <li>
                      <Link to="/music-right-management">
                        <RiArrowRightSLine /> Rights management
                      </Link>
                      </li>
                    {/* <li>
                      <Link to="#">
                        <RiArrowRightSLine /> MS-XBOX
                      </Link>
                    </li> */}
                  </ul>
                </div>
              </Col>

              {/* <Col xs={12} sm={6} md={6} lg={3}>
                <div className="widget footer-widget">
                  <h3 className="widget_title">Get in Touch </h3>
                  <div className="vs-widget-about">
                    <div className="footer-contact-us widget_title_list">
                      <FaLocationDot
                        className="icon-btn fal fa-map-marker-alt text-white"
                        size={20}
                      />
                      <p className="contact-info widget_title_list">
                        Nearest Metro: Dashrathpuri (Approx 100 Meter Distance){" "}
                        <br />
                        A2, 2nd Floor Palam Dabri Road, Mahavir Enclave Dwarka,
                        New Delhi - 110045 <br /> <br />{" "}
                        <b>LandMark - KFC/PizzaHut/DIY</b>
                      </p>
                    </div>
                      <div className="footer-contact-us">
                        <FaWhatsapp
                          className="icon-btn fal fa-phone text-white"
                          size={20}
                        />

                        <p
                          className="contact-info widget_title_list"
                          style={{ marginTop: "10px" }}
                        >
                          <a
                            href="https://wa.me/918178035854"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "none" }}
                          >
                            +91 81780 35854
                          </a>
                        </p>
                      </div>
                    <div className="footer-contact-us">
                      <MdEmail
                        className="icon-btn fal fa-phone text-white"
                        size={20}
                      />
                      <p className="contact-info" style={{ marginTop: "10px" }}>
                        <Link
                          to="mailto:support@fttunes.com"
                          style={{ textDecoration: "none" }}
                        >
                          music@fttunes.com
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </Col> */}
                <Col xs={12} sm={6} md={6} lg={3}>  
                <div className="widget widget_nav_menu footer-widget">
                  <h3 className="widget_title">Earn Money from Your Music</h3>
                  <div className="menu-all-pages-container">
                    <ul className="widget_title_list">
                      <li>
                        <Link to="/music-distribution-pricing">
                          <RiArrowRightSLine /> Pricing
                        </Link>
                      </li>
                       <li>
                        <Link to="/best-music-distribution-india">
                          <RiArrowRightSLine /> Best Music Distribution India
                        </Link>
                      </li>
                        <li>
                        <Link to="/get-verified-on-spotify">
                          <RiArrowRightSLine /> Spotify for Artists  
                        </Link>
                      </li>
                        <li>
                        <Link to="/distribute-music-on-apple-music">
                          <RiArrowRightSLine /> Apple Music Distribute   
                        </Link>
                      </li>
                        <li>
                        <Link to="/get-music-on-jio-saavn">
                          <RiArrowRightSLine /> Get Music On Jio Saavn   
                        </Link>
                      </li>
                        <li>
                        <Link to="/get-music-on-tik-tok">
                          <RiArrowRightSLine /> Get Music On Tik-Tok   
                        </Link>
                      </li>
                        <li>
                        <Link to="/get-music-on-deezer">
                          <RiArrowRightSLine /> Get Music On Deezer   
                        </Link>
                      </li>
                        <li>
                        <Link to="/get-music-on-boomplay">
                          <RiArrowRightSLine /> Get Music On Boomplay   
                        </Link>
                      </li>
                         <li>
                        <Link to="/music-stores">
                          <RiArrowRightSLine /> All Music Stores   
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={6} md={6} lg={3}>  
                <div className="widget widget_nav_menu footer-widget">
                  <h3 className="widget_title">Useful Links</h3>
                  <div className="menu-all-pages-container">
                    <ul className="widget_title_list">
                      <li>
                        <a
                          href="https://dashboard.fttunes.com/index.php"
                          // target="_blank"
                          rel="noopener noreferrer"
                        >
                          <RiArrowRightSLine /> Login
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://dashboard.fttunes.com/register.php"
                          // target="_blank"
                          rel="noopener noreferrer"
                        >
                          <RiArrowRightSLine /> Signup
                        </a>
                      </li>
                      <li>
                        <Link to="/sell-your-music">
                          <RiArrowRightSLine /> Sell Your Music
                        </Link>
                      </li>
                      <li>
                        <Link to="/music-publishing">
                          <RiArrowRightSLine /> Music Publishing
                        </Link>
                      </li>
                      <li>
                        <Link to="/youtube-content-id">
                          <RiArrowRightSLine /> YouTube Content ID
                        </Link>
                      </li>
                       <li>
                        <Link to="/youtube-promotion">
                          <RiArrowRightSLine /> YouTube Promotion
                        </Link>
                      </li>
                      <li>
                        <Link to="/youtube-monetization">
                          <RiArrowRightSLine /> YouTube Monetization
                        </Link>
                      </li>
                         <li>
                        <Link to="/digital-distribution">
                          <RiArrowRightSLine /> Digital Distribution
                        </Link>
                      </li>
                       <li>
                        <Link to="/payonline">
                          <RiArrowRightSLine /> Pay Online  
                        </Link>
                      </li>
                      <li>
                        <a
                          href="/sitemap.xml"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <RiArrowRightSLine /> Sitemap
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </Col>

            </Row>
          </Container>
        </div>
<div className="footer-copyright bg-black z-index-step1">
  <Container>
    <Row>
      <div className="copyright-wrapper">
        
        <span>
          ©️ 2022-26. All rights reserved by{" "}
          <Link>FINAL TAKE PRODUCTION PVT LTD</Link>
        </span>

         <span>
          Developed & Managed by{" "}
          <a
            href="https://www.eweblink.net/"
            target="_blank"
            rel="noopener noreferrer"
          >
            eWeblink
          </a>
        </span>

        <span>
          Made with ❤️ in INDIA for the World
        </span>


      </div>
    </Row>
  </Container>
</div>
      </footer>
    </div>
  );
};

export default Footers;
